// const config: Map<string, any> = new Map<string, any>();
//
// config.set("localDev", {
//   apiEndpoint: "https://localhost:5001",
//   zendeskKey: "974f2a3f-5758-4026-98de-9e772611e781",
//   recurlyKey: "ewr1-tkuuLghFXFuWiIgzBwvwJv"
// });
// config.set("dev", {
//   apiEndpoint: "https://api.dev.peoplekeep.ninja",
//   zendeskKey: "974f2a3f-5758-4026-98de-9e772611e781",
//   recurlyKey: "ewr1-tkuuLghFXFuWiIgzBwvwJv",
//   inspectletKey: 754723772
// });
// config.set("UAT", {
//   apiEndpoint: "https://api.peoplekeep.ninja",
//   zendeskKey: "974f2a3f-5758-4026-98de-9e772611e781",
//   recurlyKey: "ewr1-tkuuLghFXFuWiIgzBwvwJv"
// });
// config.set("prod", {
//   apiEndpoint: "https://apiv2.peoplekeep.com",
//   zendeskKey: "f88812a4-2b26-47b7-aa4b-f58704690427",
//   recurlyKey: "ewr1-2zCSBWIHCs0nRDBXjkvbnZ",
//   inspectletKey: 1746009139
// });

export enum ProductIds {
  IchraId = 1,
  QsehraId = 2,
  GroupHraId = 3,
  Perks = 4,
}

export const InspectletKey = 1746009139

export const ZendeskKeys = {
  1: 'e39c8a32-3542-491e-ac31-a402d24c27bb',
  2: 'ec671564-07cf-4b6e-a19d-9a177521e814',
  3: 'f88812a4-2b26-47b7-aa4b-f58704690427',
  4: '03e1a1a1-9e1a-475d-a35b-1b1706b515ce',
}

export const W2ReportNotificationYear = 2023

export default {
  apiEndpoint: 'https://localhost:5001',
  zendeskKey: ZendeskKeys,
  recurlyKey: 'ewr1-tkuuLghFXFuWiIgzBwvwJv',
  env: 'development',
  inspectletKey: InspectletKey,
}
